import React from 'react';
import clsx from 'clsx';
import { Tabs, Tab } from '@material-ui/core';
import MetricsSection from './MetricsSection/MetricsSection';
import ViolationsSection from './ViolationsSection';

const convertQualityScoreToLetter = (n)=> {
    let quality = n;
	if (typeof quality !== "number" || Number.isNaN(quality)|| quality <= 0) return "-";
	if (quality <= 1) quality *= 100;
	if (quality < 10) return "D⁻";
	if (quality < 25) return "D";
	if (quality < 33) return "D⁺";
	if (quality < 38) return "C⁻";
	if (quality < 50) return "C";
	if (quality < 55) return "C⁺";
	if (quality < 60) return "B⁻";
	if (quality < 73) return "B";
	if (quality < 80) return "B⁺";
	if (quality < 83) return "A⁻";
	if (quality < 93) return "A";
	return "A⁺";
};

const colorizeRank = (value) => {

    if(value === '' || value === undefined) return 'GRAY';

    const rank =  convertQualityScoreToLetter(value)[0];

    switch (rank) {
        case 'A':
            return 'rgb(56, 142, 60)';
        case 'B':
            return 'rgb(251, 192, 45)';
        case 'C':
            return 'rgb(230, 74, 25)';
        case 'D':
            return 'rgb(211, 47, 47)';
        default: 
            return 'GRAY';
    }
    
}



function TabPanel(props) {
    const { children, value, index } = props;
  
    return (
      <div>
        {value === index && (
            <div>{children}</div>
        )}
      </div>
    );
}

const QualityTabs = (props) => {

    const{
        metricsData
    } = props;

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return(
        <>
            <Tabs
            value={value}
            onChange={handleChange}
            TabIndicatorProps={{style: {background:'#0c4d82', minWidth: '0px'}}}
            >
                <Tab
                    style={{minWidth: '0px', minHeight: '0px', padding: '1rem 0.5rem'}}
                    label={
                        <div style={{display: 'flex',flexDirection: 'column'}} className={ value !== 0 ? clsx('tabsSvg'): clsx('selectedTab')}>
                            <svg style ={{ width: '2rem', display: 'flex', alignSelf: 'center'}}focusable="false" viewBox="0 0 24 24" aria-hidden="true" >
                                <path d="M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z"/>
                            </svg>
                            <span  >Overview</span>
                        </div>
                    }
                />
                <Tab  
                    style={{minWidth: '0px', minHeight: '0px', padding: '1rem 0.5rem'}}
                    label={
                        <div style={{display: 'flex',flexDirection: 'column'}} className={ value !== 1 ? clsx('tabsSvg'): clsx('selectedTab')}>
                            <svg style ={{ width: '2rem', display: 'flex', alignSelf: 'center'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" >
                                <path  d="M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"/>
                            </svg>
                            <span >Metrics</span>
                        </div>
                }/>
                <Tab 
                    style={{minWidth: '0px', minHeight: '0px', padding: '1rem 0.5rem'}}
                    label={
                        <div style={{display: 'flex',flexDirection: 'column'}} className={ value !== 2 ? clsx('tabsSvg'): clsx('selectedTab')}>
                            <svg style ={{ width: '2rem', display: 'flex', alignSelf: 'center'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="ErrorOutlineRoundedIcon">
                                <path d="M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z"/>
                            </svg>
                            <span >Violations</span>
                        </div>
                } />
            </Tabs>
            <TabPanel value={value} index={0} >
                <ProjectOverview
                    metricsData={metricsData}
                />
            </TabPanel>
            <TabPanel value={value} index={1} >
                <MetricsSection
                    metricsData={metricsData}
                />
            </TabPanel>
            <TabPanel value={value} index={2} >
                <ViolationsSection
                    metricsData={metricsData}
                />
            </TabPanel> 
        </>
    )
}

const ProjectOverview = (props) => {
    
    const{
        metricsData
    } = props;

    return(
        <>
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <QualityCard cause='overal' name='Overal Project Rating' value={metricsData !== undefined ? metricsData.overallQualityScore : 0}/>
            </div>

            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '2rem'}}>
                <QualityCard cause='maintainability' name='Maintainability' value={ metricsData !== undefined ? metricsData.characteristics.maintainabilityScore : 0}/>
                <QualityCard cause='security' name='Security' value={metricsData !== undefined ? metricsData.characteristics.securityScore : 0}/>
                <QualityCard cause='readability' name='Readability' value={metricsData !== undefined ? metricsData.characteristics.readabilityScore : 0}/>
                <QualityCard cause='reusability' name='Reusability' value={metricsData !== undefined ? metricsData.characteristics.reusabilityScore : 0}/>
            </div>

            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '2rem'}}>
                <SubQualityCard number={metricsData !== undefined ? metricsData.HighLevelMetrics.LogicalLOC : '-'} title='TOTAL LOGICAL LOC ANALYZED' />
                <SubQualityCard number={metricsData !== undefined ? metricsData.HighLevelMetrics.PhysicalLOC : '-'} title='TOTAL PHYSICAL LOC ANALYZED'/>
                <SubQualityCard number={metricsData !== undefined ? metricsData.HighLevelMetrics.NumFiles : '-'} title='NUMBER OF FILES'/>
                <SubQualityCard number={`${(metricsData !== undefined ? metricsData.HighLevelMetrics.DuplicateCodePct : '-' )} %`} title='DUPLICATE CODE'/>
            </div>

            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '2rem'}}>
                <SubQualityCard number={metricsData !== undefined ? parseFloat(metricsData.HighLevelMetrics.MI.toFixed(3)) : '-'} title='MAINTAINABILITY INDEX'/>
                <SubQualityCard number={metricsData !== undefined ? parseFloat(metricsData.HighLevelMetrics.CC.toFixed(3)) : '-'} title='CYCLOMATIC COMPLEXITY' />
                <SubQualityCard number={metricsData !== undefined ? parseFloat(metricsData.totalViolationsCount.toFixed(3)) : '-'} title='TOTAL NUMBER OF VIOLATIONS'/>
                <SubQualityCard number={metricsData !== undefined ? parseFloat(metricsData.HighLevelMetrics.EffortInDays.toFixed(3)) : '-'} title='CODE EFFORTS (DAYS)'/>
            </div>

        </>
    )
}

const QualityCard = ({cause,value,name}) => 
    (
        <div style={{border: 'solid', borderColor: '#0c4d82', borderRadius: '0.5rem',borderWidth: '2px', display:'flex', flexDirection:'column', padding: '1rem', width: '20%'}}>  
            {cause === 'overal' && <svg  style={{fill: '#616161',width: '1.5rem'}} focusable="false" viewBox="0 0 24 24" ><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/></svg> }           
            {cause === 'maintainability' && <svg style={{fill: '#616161',width: '1.5rem'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="BuildIcon"><path d="m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/></svg> }
            {cause === 'security' && <svg  style={{fill: '#616161',width: '1.5rem'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="SecurityIcon"><path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/></svg>}
            {cause === 'readability' && <svg style={{fill: '#616161',width: '1.5rem'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="MenuBookIcon"><path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/><path d="M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zm4.5 1.84c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z"/></svg> }
            {cause === 'reusability' && <svg style={{fill: '#616161',width: '1.5rem'}} focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="CachedIcon"><path d="m19 8-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"/></svg>}
            <span style={{display: 'flex', justifyContent: 'center', fontSize: '3.75rem',fontWeight: '400', color:  colorizeRank(value), lineHeight: 1}}> {convertQualityScoreToLetter(value)}</span>
            <span style={{display: 'flex', justifyContent: 'center', lineHeight: 1.6, fontWeight: 500, fontSize: '1.125rem'}}> {name}</span>
        </div>
    )

const SubQualityCard = ({number, title}) => 
    (
        <div style={{display: 'flex', flexDirection: 'column' ,backgroundColor: 'rgb(207, 216, 224)', borderRadius: '0.5rem', padding: '1rem', width: '20%' }}>
            <span style={{display: 'flex' ,justifyContent: 'center', color: '#0c4d82', fontSize: '2.125rem', fontWeight: '700', lineHeight: '1.235'}}> {number}</span>
            <span style={{display: 'flex' ,justifyContent: 'center', color: '#0c4d82', fontSize: '0.875rem', fontWeight: '700', lineHeight: '1.43'}}>{title}</span>
        </div>
    )

export default QualityTabs;
export {
    convertQualityScoreToLetter,
    colorizeRank
}